import {
    DescriptionRounded,
    EditNoteRounded,
    InsightsRounded,
} from "@mui/icons-material";
import { LLMClassifierPurpose } from "models/LLMs/LLMClassifierPurpose";

export function LLMPurposeIcon({ purpose }: { purpose: LLMClassifierPurpose }) {
    switch (purpose) {
        case LLMClassifierPurpose.Quality:
            return <DescriptionRounded htmlColor="white" />;
        case LLMClassifierPurpose.Insights:
            return <InsightsRounded htmlColor="white" />;
        case LLMClassifierPurpose.ExtractData:
            return <EditNoteRounded htmlColor="white" />;
        default:
            return null;
    }
}
